import { BUSINESS, businessAddressInline } from "../lib/business";

export default function PrivacyPolicy() {
	return (
		<section className="container py-10 max-w-4xl mx-auto">
			<h1 className="text-3xl font-bold text-foreground mb-6">
				Privacy Policy
			</h1>

			<div className="prose dark:prose-invert max-w-none">
				<p className="text-muted-foreground mb-6">
					Ultimo aggiornamento: 30 dicembre 2025
				</p>

				<div className="space-y-8 text-foreground/80">
					<section>
						<h2 className="text-2xl font-semibold text-foreground mb-4">
							1. Titolare del Trattamento
						</h2>
						<p>
							Il Titolare del trattamento dei dati è{" "}
							<strong>{BUSINESS.legalName}</strong>, con sede in{" "}
							{businessAddressInline}, P.IVA {BUSINESS.vatNumber}.
							<br />
							Email:{" "}
							<a
								href="mailto:apicoltura.depiccoli@gmail.com"
								className="text-primary hover:underline"
							>
								apicoltura.depiccoli@gmail.com
							</a>
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-foreground mb-4">
							2. Dati Raccolti
						</h2>
						<p className="mb-3">
							Nel corso della navigazione e dell'utilizzo del nostro sito
							e-commerce, raccogliamo i seguenti dati personali:
						</p>
						<ul className="list-disc pl-6 space-y-2">
							<li>
								<strong>Dati identificativi:</strong> nome, cognome, indirizzo
								email
							</li>
							<li>
								<strong>Dati di contatto:</strong> indirizzo di spedizione,
								numero di telefono (se fornito)
							</li>
							<li>
								<strong>Dati di pagamento:</strong> informazioni gestite tramite
								Stripe (non memorizziamo direttamente i dati della carta di
								credito)
							</li>
							<li>
								<strong>Dati di navigazione:</strong> indirizzo IP, tipo di
								browser, pagine visitate
							</li>
							<li>
								<strong>Dati relativi agli ordini:</strong> prodotti acquistati,
								cronologia ordini, preferenze
							</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-foreground mb-4">
							3. Finalità del Trattamento
						</h2>
						<p className="mb-3">
							I dati personali sono trattati per le seguenti finalità:
						</p>
						<ul className="list-disc pl-6 space-y-2">
							<li>
								<strong>Gestione ordini:</strong> elaborazione, conferma e
								spedizione degli ordini
							</li>
							<li>
								<strong>Comunicazioni:</strong> invio di email di conferma
								ordine, aggiornamenti sulla spedizione e tracking
							</li>
							<li>
								<strong>Assistenza clienti:</strong> gestione richieste, reclami
								e supporto
							</li>
							<li>
								<strong>Adempimenti legali:</strong> fatturazione, contabilità e
								obblighi fiscali
							</li>
							<li>
								<strong>Miglioramento servizi:</strong> analisi del
								comportamento degli utenti per ottimizzare l'esperienza
								d'acquisto
							</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-foreground mb-4">
							4. Base Giuridica del Trattamento
						</h2>
						<p className="mb-3">
							Il trattamento dei dati personali si basa su:
						</p>
						<ul className="list-disc pl-6 space-y-2">
							<li>
								<strong>Esecuzione del contratto:</strong> per processare ed
								evadere i tuoi ordini
							</li>
							<li>
								<strong>Consenso:</strong> per l'invio di comunicazioni di
								marketing (se richiesto)
							</li>
							<li>
								<strong>Obblighi legali:</strong> per adempiere a obblighi
								fiscali e contabili
							</li>
							<li>
								<strong>Legittimo interesse:</strong> per prevenire frodi e
								garantire la sicurezza del sito
							</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-foreground mb-4">
							5. Condivisione dei Dati
						</h2>
						<p className="mb-3">
							I tuoi dati personali possono essere condivisi con:
						</p>
						<ul className="list-disc pl-6 space-y-2">
							<li>
								<strong>Fornitori di servizi di pagamento:</strong> Stripe per
								l'elaborazione dei pagamenti
							</li>
							<li>
								<strong>Corrieri:</strong> per la consegna dei prodotti ordinati
							</li>
							<li>
								<strong>Servizi di hosting:</strong> Supabase per la gestione
								del database
							</li>
							<li>
								<strong>Servizi email:</strong> Resend per l'invio di
								comunicazioni transazionali
							</li>
						</ul>
						<p className="mt-3">
							Tutti i fornitori terzi sono selezionati con cura e tenuti a
							rispettare il GDPR e a proteggere adeguatamente i tuoi dati.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-foreground mb-4">
							6. Conservazione dei Dati
						</h2>
						<p>
							I dati personali sono conservati per il tempo necessario a
							soddisfare le finalità per cui sono stati raccolti:
						</p>
						<ul className="list-disc pl-6 space-y-2 mt-3">
							<li>
								<strong>Dati degli ordini:</strong> 10 anni per obblighi fiscali
								e contabili
							</li>
							<li>
								<strong>Account utente:</strong> fino alla cancellazione
								dell'account da parte dell'utente
							</li>
							<li>
								<strong>Dati di navigazione:</strong> massimo 24 mesi
							</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-foreground mb-4">
							7. Diritti dell'Interessato
						</h2>
						<p className="mb-3">In conformità al GDPR, hai il diritto di:</p>
						<ul className="list-disc pl-6 space-y-2">
							<li>
								<strong>Accesso:</strong> ottenere conferma dell'esistenza dei
								tuoi dati e riceverne copia
							</li>
							<li>
								<strong>Rettifica:</strong> correggere dati inesatti o
								incompleti
							</li>
							<li>
								<strong>Cancellazione:</strong> richiedere la cancellazione dei
								tuoi dati ("diritto all'oblio")
							</li>
							<li>
								<strong>Limitazione:</strong> limitare il trattamento in
								determinate circostanze
							</li>
							<li>
								<strong>Portabilità:</strong> ricevere i tuoi dati in formato
								strutturato
							</li>
							<li>
								<strong>Opposizione:</strong> opporti al trattamento per
								finalità di marketing
							</li>
							<li>
								<strong>Revoca del consenso:</strong> revocare il consenso in
								qualsiasi momento
							</li>
						</ul>
						<p className="mt-3">
							Per esercitare i tuoi diritti, contattaci all'indirizzo email:
							<a
								href="mailto:apicoltura.depiccoli@gmail.com"
								className="text-primary hover:underline ml-1"
							>
								apicoltura.depiccoli@gmail.com
							</a>
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-foreground mb-4">
							8. Cookie
						</h2>
						<p>
							Il nostro sito utilizza cookie tecnici essenziali per il
							funzionamento del sito e la gestione del carrello. Non utilizziamo
							cookie di profilazione o tracciamento di terze parti senza il tuo
							consenso.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-foreground mb-4">
							9. Sicurezza dei Dati
						</h2>
						<p>
							Adottiamo misure tecniche e organizzative adeguate per proteggere
							i tuoi dati personali da accessi non autorizzati, perdita,
							distruzione o alterazione. Tutti i dati sono trasmessi in modo
							sicuro tramite protocollo HTTPS e memorizzati su server protetti.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-foreground mb-4">
							10. Modifiche alla Privacy Policy
						</h2>
						<p>
							Ci riserviamo il diritto di modificare questa Privacy Policy in
							qualsiasi momento. Le modifiche saranno pubblicate su questa
							pagina con indicazione della data di ultimo aggiornamento. Ti
							invitiamo a consultare regolarmente questa pagina per essere
							sempre informato su come proteggiamo i tuoi dati.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-foreground mb-4">
							11. Reclami
						</h2>
						<p>
							Hai il diritto di presentare un reclamo all'Autorità Garante per
							la Protezione dei Dati Personali se ritieni che il trattamento dei
							tuoi dati violi il GDPR.
							<br />
							<strong>Garante per la protezione dei dati personali</strong>
							<br />
							Sito web:{" "}
							<a
								href="https://www.garanteprivacy.it"
								target="_blank"
								rel="noopener noreferrer"
								className="text-primary hover:underline"
							>
								www.garanteprivacy.it
							</a>
						</p>
					</section>

					<section className="border-t border-border pt-6 mt-8">
						<p className="text-sm text-muted-foreground">
							Per qualsiasi domanda o richiesta relativa alla presente Privacy
							Policy, non esitare a contattarci all'indirizzo email{" "}
							<a
								href="mailto:apicoltura.depiccoli@gmail.com"
								className="text-primary hover:underline"
							>
								apicoltura.depiccoli@gmail.com
							</a>
						</p>
					</section>
				</div>
			</div>
		</section>
	);
}
